import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import "./PostTextComponent.scss";
import { getTextWithWrapHtml } from "../../redux/constants";
import { Tooltip } from "antd";

const PostTextComponent = ({
  postText,
  setAutoPlay,
  setIsModalLoader,
  setIsModalOpen,
  setIsModalData,
  isModalOpen,
  trendView,
  el,
  dynamicHeight,
  highlightWord,
  isDeepDiveDashboardView = false,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );

  const [lineClamp, setLineClamp] = useState(2); // Default to 2 lines
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const contentRef = useRef(null);
  const wrapperRef = useRef(null);

  const headerRef = useRef(null);
  const [refUpdated, setRefUpdated] = useState(false);

  // callback function got called when reference of slider is loaded
  const measuredHeaderRef = useCallback((node) => {
    if (node !== null) {
      headerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);

  useEffect(() => {
    setRefUpdated(!refUpdated);
  }, [headerRef?.current, headerRef?.current?.clientHeight]);

  useEffect(() => {
    const adjustLineClamp = () => {
      if (wrapperRef.current && contentRef.current) {
        const wrapperHeight = wrapperRef.current.clientHeight;
        const lineHeight = parseFloat(
          getComputedStyle(contentRef.current).lineHeight
        );
        const numberOfLines = Math.floor(wrapperHeight / lineHeight);
        setLineClamp(numberOfLines);
        setIsTruncated(
          contentRef.current.scrollHeight > wrapperRef.current.clientHeight
        );
      }
    };

    setTimeout(() => {
      adjustLineClamp();
    }, 100);
    window.addEventListener("resize", adjustLineClamp);

    return () => window.removeEventListener("resize", adjustLineClamp);
  }, [postText, lineClamp]);

  const showModal = (data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    // To Stop Carousel in Brand Post Screen
    if (
      authParams?.screen_id === "000-000-562" &&
      !trendView &&
      !isDeepDiveDashboardView
    ) {
      setAutoPlay(false);
    }
    const ThreeDGlobalPage =
      (authParams?.screen_id === "000-000-555" ||
        authParams?.screen_id === "000-000-551" ||
        authParams?.screen_id === "000-000-557" ||
        authParams?.screen_id === "000-000-564") &&
      !isDeepDiveDashboardView
        ? true
        : false;
    const updateData = ThreeDGlobalPage
      ? {
          ...data,
          isModalOpen: !isModalOpen,
        }
      : data;
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(updateData);
  };

  return (
    <div
      // style={{ height: dynamicHeight ? dynamicHeight : "100%" }}
      style={{ height: "100%" }}
      className="dynamic-content-wrapper"
      ref={wrapperRef}
    >
      <div
        className={`dynamic-content ${isExpanded ? "expanded" : ""}`}
        style={{
          // color: "var(--locobuzz-chart-text--color)",
          WebkitLineClamp: isExpanded ? "unset" : lineClamp,
          lineClamp: isExpanded ? "unset" : lineClamp,
          // height: dynamicHeight ? dynamicHeight : "100%",
          height:
            "calc(" +
            dynamicHeight +
            " - " +
            (headerRef?.current?.clientHeight
              ? headerRef?.current?.clientHeight
              : 0) +
            "px)",
        }}
        ref={contentRef}
      >
        {getTextWithWrapHtml(postText, "", highlightWord)}
      </div>

      {isTruncated && (
        <div ref={measuredHeaderRef}>
          <Tooltip
            title={
              personalizationSettingsObj?.isPersonalizationPreviewOpen
                ? "Actions are not allowed while customizing"
                : ""
            }
          >
            <button
              onClick={() => showModal(el)}
              className={`read-more-button ${
                personalizationSettingsObj?.isPersonalizationPreviewOpen
                  ? "disabled-cursor"
                  : ""
              }`}
            >
              {isExpanded ? "Read Less" : "Read More"}
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default PostTextComponent;
